<script>
  /* global Global */
  import AdminAction from './AdminAction.svelte';
  import ConfirmModal from '../common/ConfirmModal.svelte';
  import Pipe from '../symbols/Pipe.svelte';
  import Common from '../js/common.js';

  export let value;
  export let small = false;
  export let pinned = false;
  export let lang = undefined;
  export let admin;

  let displayConfirmModal = false;
  let confirmModalMessage;
  let messageBox;

  async function deleteArticle () {
    messageBox = {
      cs: { color: 'blue', message: i18n.deletingInProgress.cs },
      en: { color: 'blue', message: i18n.deletingInProgress.en },
    };

    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/admin/articles/delete/${value.id}`);

    if (response.ok) {
      window.location.reload();
    } else {
      messageBox = {
        cs: { color: 'red', message: i18n.unexpectedError.cs },
        en: { color: 'red', message: i18n.unexpectedError.en },
      };
    }
  }

  if (admin) {
    confirmModalMessage = {
      cs: `Opravdu chcete smazat článek "[${Common.addZeros(value.id)}] ${value.code}"?`,
      en: `Do you really want to delete article "[${Common.addZeros(value.id)}] ${value.code}"?`,
    };
  }

  const COLORS = ['grey', 'red', 'purple', 'blue', 'cyan', 'green', 'yellow', 'orange', 'brown'];

  const i18n = {
    pinned: {
      cs: 'Připnuto',
      en: 'Pinned',
    },
    edit: {
      cs: 'Upravit',
      en: 'Edit',
    },
    delete: {
      cs: 'Smazat',
      en: 'Delete',
    },
    inactive: {
      cs: 'Neaktivní',
      en: 'Inactive',
    },
    deletingInProgress: {
      cs: 'Probíhá mazání článku...',
      en: 'Article deleting in progress...',
    },
    unexpectedError: {
      cs: '(Ne)očekávaná chyba. `E29`',
      en: '(Un)expected error. `E29`',
    },
  };

  const projectStyle = Global.project.style;
  const years = Global.years;
</script>

<a href='./#/articles/{value.code}' class='article' class:article-old={projectStyle === 'old' || projectStyle === 'sharp'}>
  <div class='article-box' class:article-box-small={small}>
    <img class='article-box-image' src='img/article/{value.photo ? `${value.code}-${value.photo}` : 'default'}.jpg'
      alt='{value.title.en} article photo'/>

    {#if admin}
      <div class='article-box-admin'>
        <AdminAction value={i18n.edit[lang]} icon='edit'
          onClick={() => { window.location.href = `./#/admin/articles/${value.code}`; }}/>

        <AdminAction value={i18n.delete[lang]} icon='delete'
          onClick={() => { displayConfirmModal = true; }}/>
      </div>

      {#if !value.active}
        <div class='article-box-disabled'>
          <div class='article-box-disabled-text'>
            {i18n.inactive[lang]}
          </div>
        </div>
      {:else if value.timestamp > Common.getDbDate() + Common.getDbTime()}
        <div class='article-box-disabled'>
          <div class='article-box-disabled-text'>
            {Common.convertDbFullDate(value.timestamp)}
          </div>
        </div>
      {/if}
    {/if}

    <div class='article-box-title'>
      <div class='article-box-title-text'> {value.title[lang]} </div>
    </div>

    <div class='article-box-text'>
      <div class='article-box-text-perex'>
        {@html Common.escapeMarkdown(value.perex[lang])}

        <div class='article-box-text-perex-gradient'/>
      </div>

      <div class='article-box-text-info'>
        <div class='article-box-text-info-details'>
          {#if years.length > 1}
            <div class='article-box-text-info-details-year'
              class:article-box-text-info-details-year-grey={COLORS[years.indexOf(value.year) % COLORS.length] === 'grey'}
              class:article-box-text-info-details-year-red={COLORS[years.indexOf(value.year) % COLORS.length] === 'red'}
              class:article-box-text-info-details-year-purple={COLORS[years.indexOf(value.year) % COLORS.length] === 'purple'}
              class:article-box-text-info-details-year-blue={COLORS[years.indexOf(value.year) % COLORS.length] === 'blue'}
              class:article-box-text-info-details-year-cyan={COLORS[years.indexOf(value.year) % COLORS.length] === 'cyan'}
              class:article-box-text-info-details-year-green={COLORS[years.indexOf(value.year) % COLORS.length] === 'green'}
              class:article-box-text-info-details-year-yellow={COLORS[years.indexOf(value.year) % COLORS.length] === 'yellow'}
              class:article-box-text-info-details-year-orange={COLORS[years.indexOf(value.year) % COLORS.length] === 'orange'}
              class:article-box-text-info-details-year-brown={COLORS[years.indexOf(value.year) % COLORS.length] === 'brown'}>

              {value.year}
            </div>
          {/if}

          {#if pinned}
            <div class='article-box-text-info-details-pinned'> {i18n.pinned[lang]} </div>
          {:else if admin}
            <div class='article-box-text-info-details-views'> <span class='material-icons'> visibility </span> {value.views} </div>
          {/if}
        </div>

        <div class='article-box-text-info-author-and-date'>
          {value.author.firstName} {value.author.lastName} <Pipe/> {value.date}
        </div>
      </div>
    </div>
  </div>
</a>

{#if admin}
  <ConfirmModal bind:display={displayConfirmModal} message={confirmModalMessage[lang]}
    onConfirm={deleteArticle} messageBox={messageBox ? messageBox[lang] : undefined} bind:lang/>
{/if}

<style>
  .article {
    width: 100%;

    text-decoration: none;

    color: inherit;
  }

  .article-box {
    position: relative;

    display: flex;

    height: 300px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);

    transition: box-shadow 1s ease-in-out, transform 1s ease-in-out;
  }

  .article-box:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-4);

    transform: scale(1.025);
  }

  .article-box-image {
    flex-shrink: 0;

    width: 450px;
    height: 100%;

    border-radius: var(--radius-lg) 0px 0px var(--radius-lg);

    object-fit: cover;

    filter: brightness(90%);

    transition: filter 1s ease-in-out;
  }

  .article-box:hover .article-box-image {
    filter: brightness(100%);
  }

  .article-box-admin {
    position: absolute;
    top: 20px;
    left: 20px;

    display: flex;
    justify-content: space-between;

    width: 410px;

    z-index: 2;
  }

  .article-box-disabled {
    position: absolute;

    width: 100%;
    height: 100%;

    border-radius: var(--radius-lg);

    z-index: 1;

    background: rgba(255, 255, 255, 0.75);
  }

  .article-box-disabled-text {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 450px;
    height: 100%;

    text-transform: uppercase;

    font-family: 'JetBrains Mono';
    font-weight: bold;
  }

  .article-box-title {
    position: absolute;
    bottom: 20px;
    left: 20px;

    max-width: 410px;
  }

  .article-box-title-text {
    width: fit-content;

    padding: 5px 10px;

    font-family: var(--font-secondary);
    font-size: 32px;
    font-weight: bold;

    background: linear-gradient(135deg, var(--red), var(--dark-red));
    color: var(--white);
  }

  .article-old .article-box-title-text {
    background: var(--red);
  }

  .article-box-text {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 260px;

    padding: 20px;

    overflow: hidden;
  }

  .article-box-text-perex {
    position: relative;

    height: calc(100% - 22.5px);

    line-height: 1.4;

    overflow: hidden;
  }

  .article-box-text-perex-gradient {
    position: absolute;
    bottom: 0px;

    width: 100%;
    height: 60px;

    background: linear-gradient(rgba(245, 245, 245, 0), rgba(245, 245, 245, 1) 87.5%);

    overflow-wrap: anywhere;
  }

  .article-box-text-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;

    height: 22.5px;

    color: var(--grey-7);
  }

  .article-box-text-info-details {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .article-box-text-info-details-year {
    display: flex;
    align-items: center;

    height: 22.5px;

    padding: 0px 10px;

    border-radius: 11.25px;

    font-weight: 550;
  }

  .article-box-text-info-details-year-grey {
    background: var(--grey-0);
    color: var(--grey-8);
  }

  .article-box-text-info-details-year-red {
    background: var(--red-0);
    color: var(--red-8);
  }

  .article-box-text-info-details-year-purple {
    background: var(--purple-0);
    color: var(--purple-8);
  }

  .article-box-text-info-details-year-blue {
    background: var(--blue-0);
    color: var(--blue-8);
  }

  .article-box-text-info-details-year-cyan {
    background: var(--cyan-0);
    color: var(--cyan-8);
  }

  .article-box-text-info-details-year-green {
    background: var(--green-0);
    color: var(--green-8);
  }

  .article-box-text-info-details-year-yellow {
    background: var(--yellow-0);
    color: var(--yellow-8);
  }

  .article-box-text-info-details-year-orange {
    background: var(--orange-0);
    color: var(--orange-8);
  }

  .article-box-text-info-details-year-brown {
    background: var(--brown-0);
    color: var(--brown-8);
  }

  .article-box-text-info-details-pinned {
    font-weight: 550;

    color: var(--tertiary);
  }

  .article-box-small {
    height: 250px;
  }

  .article-box-small .article-box-image {
    width: 375px;
  }

  .article-box-small .article-box-admin {
    width: 335px;
  }

  .article-box-small .article-box-disabled-text {
    width: 375px;
  }

  .article-box-small .article-box-title {
    max-width: 335px;
  }

  .article-box-small .article-box-title-text {
    font-size: 24px;
  }

  .article-box-small .article-box-text {
    height: 210px;
  }

  :global(body.dark) .article-box {
    background: var(--grey-8);
  }

  :global(body.dark) .article-box:hover {
    box-shadow: 0px 0px 10px 0px var(--black);
  }

  :global(body.dark) .article-box-image {
    filter: brightness(80%);
  }

  :global(body.dark) .article-box:hover .article-box-image {
    filter: brightness(90%);
  }

  :global(body.dark) .article-box-disabled {
    background: rgba(33, 33, 33, 0.75);
  }

  :global(body.dark) .article-box-title-text {
    background: linear-gradient(135deg, var(--red-dark), var(--dark-red-dark));
    color: var(--grey-3);
  }

  :global(body.dark) .article-old .article-box-title-text {
    background: var(--red-dark);
  }

  :global(body.dark) .article-box-text-perex-gradient {
    background: linear-gradient(rgba(66, 66, 66, 0), rgba(66, 66, 66, 1) 87.5%);
  }

  :global(body.dark) .article-box-text-info {
    color: var(--grey-5);
  }

  :global(body.dark) .article-box-text-info-details-year-grey {
    background: var(--grey-7);
    color: var(--grey-3);
  }

  :global(body.dark) .article-box-text-info-details-year-red {
    background: var(--grey-7);
    color: var(--red-3);
  }

  :global(body.dark) .article-box-text-info-details-year-purple {
    background: var(--grey-7);
    color: var(--purple-3);
  }

  :global(body.dark) .article-box-text-info-details-year-blue {
    background: var(--grey-7);
    color: var(--blue-3);
  }

  :global(body.dark) .article-box-text-info-details-year-cyan {
    background: var(--grey-7);
    color: var(--cyan-3);
  }

  :global(body.dark) .article-box-text-info-details-year-green {
    background: var(--grey-7);
    color: var(--green-3);
  }

  :global(body.dark) .article-box-text-info-details-year-yellow {
    background: var(--grey-7);
    color: var(--yellow-3);
  }

  :global(body.dark) .article-box-text-info-details-year-orange {
    background: var(--grey-7);
    color: var(--orange-3);
  }

  :global(body.dark) .article-box-text-info-details-year-brown {
    background: var(--grey-7);
    color: var(--brown-3);
  }

  @media only screen and (max-width: 850px) {
    .article-box-image {
      width: 100%;

      border-radius: var(--radius-lg);
    }

    .article-box-admin {
      width: calc(100% - 40px);
    }

    .article-box-disabled-text {
      width: 100%;
    }

    .article-box-title {
      max-width: calc(100% - 40px);
    }

    .article-box-text {
      display: none;
    }

    .article-box-small .article-box-image {
      width: 100%;
    }

    .article-box-small .article-box-admin {
      width: calc(100% - 40px);
    }

    .article-box-small .article-box-disabled-text {
      width: 100%;
    }

    .article-box-small .article-box-title {
      max-width: calc(100% - 40px);
    }
  }

  @media only screen and (max-width: 500px) {
    .article-box-title-text {
      font-size: 24px;
    }
  }
</style>
